import React from 'react';
import { AppBar, Toolbar, Box, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  //const location = useLocation();

  return (
    <AppBar position='static'>
      <Toolbar
        sx={{ justifyContent: 'space-between', backgroundColor: '#ffff' }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <Link
            href='https://staticval.com'
            target='_blank'
            rel='noreferrer'
            className='text-blue-600 ml-1'
            underline='hover'
            sx={{ fontSize: 'inherit' }}
          >
            <img
              src='../images/company_logo.jpg'
              alt='Logo'
              style={{ height: '40px', marginRight: '10px' }}
            />
          </Link>
        </Box>
        {/* {location?.pathname !== '/signin' && (
          <Button color='inherit' onClick={() => navigate('/signin')}>
            Sign In
          </Button>
        )} */}
      </Toolbar>
    </AppBar>
  );
};
export default Header;
